<div data-test="bLEpweKG" class="progressbar progressbar_stacked progressbar_{{ color }}">
  <div data-test="dmA6Dj_K" class="progressbar__bar">
    <div
      data-test="cxH42KYm"
      class="progressbar__progress"
      [style.width.%]="progress"
      [attr.data-progress]="showPercentage ? (progressFormatted || progress) + '%' : ''"
      data-progress-top="data_progress_bottom"
      data-progress-right
    ></div>
  </div>
</div>
